import {
    BUILDING_INFO_SOURCE_MEANINGS,
    selectedBuildingInfoSourcePresentation,
} from '@quipex/feature/building-context';
import type { FocusedBuildingMetadataItem } from '../models';
import type { PreviewFactSourcePresentation } from './models';

export function toPreviewFactSourcePresentation(
    item: FocusedBuildingMetadataItem
): PreviewFactSourcePresentation {
    if (item.unknown) {
        const supportsGeoscape =
            item.definitionKey === 'floor_area' ||
            item.definitionKey === 'lots';
        return {
            label: 'No value',
            meaning: supportsGeoscape
                ? 'No saved or Geoscape value is available.'
                : 'No saved value is available.',
            icon: 'lucideCircleQuestionMark',
            context: { family: 'secondary', tone: 'muted' },
            iconOnly: true,
            geoscape: false,
        };
    }

    const selected = selectedBuildingInfoSourcePresentation(item.sources ?? []);
    if (selected?.source.id === 'geoscape') {
        return {
            label: 'Geoscape',
            meaning: BUILDING_INFO_SOURCE_MEANINGS['Geoscape'],
            icon: 'lucideGlobe',
            context: selected.context,
            iconOnly: false,
            geoscape: true,
        };
    }

    const label =
        selected?.source.label === 'Unit default'
            ? 'Unit default'
            : 'User supplied';
    return {
        label,
        meaning: BUILDING_INFO_SOURCE_MEANINGS[label],
        icon: 'lucideUser',
        context: { family: 'caution', tone: 'muted' },
        iconOnly: false,
        geoscape: false,
    };
}
